import LegalLayout from '@/layouts/LegalLayout';

export default function Terms() {
  return (
    <LegalLayout title="Terms and conditions" updated="draft">
      <h2>1. Who we are</h2>
      <p>
        MakeMyPartner is operated by <strong>[LEGAL ENTITY NAME]</strong>, registered at{' '}
        <strong>[REGISTERED ADDRESS]</strong>, CIN <strong>[CIN]</strong>, GSTIN{' '}
        <strong>[GSTIN]</strong>. In these terms, &ldquo;we&rdquo; and &ldquo;us&rdquo; mean that
        company. &ldquo;You&rdquo; means the person using the platform.
      </p>

      <h2>2. What this service is — and is not</h2>
      <p>
        MakeMyPartner connects members with companions for conversation and emotional support, paid
        by the minute.
      </p>
      <p>
        <strong>This is not therapy, counselling, or medical care.</strong> Companions are trained
        listeners, not licensed clinicians. Nothing said on this platform is a diagnosis, a
        treatment, or professional advice of any kind. If you are in crisis or need clinical care,
        contact a qualified professional or an emergency helpline.
      </p>
      <p>
        <strong>This is not a dating or matchmaking service</strong>, and it is not an adult
        service.
      </p>

      <h2>3. Eligibility</h2>
      <p>
        You must be <strong>18 years or older</strong> to use MakeMyPartner. We may ask you to
        verify your age or identity at any time, and may suspend an account pending that
        verification.
      </p>

      <h2>4. Coins</h2>
      <p>
        Sessions are paid for with <strong>coins</strong>, which you buy in advance. Coins are a
        prepayment for services we provide. They are:
      </p>
      <ul>
        <li>
          <strong>Not transferable</strong> — they cannot be sent to another user
        </li>
        <li>
          <strong>Not withdrawable</strong> — they cannot be converted back to cash
        </li>
        <li>
          <strong>Not refundable once consumed.</strong> See our{' '}
          <a href="/refunds">Cancellation and Refunds policy</a> for unconsumed coins.
        </li>
      </ul>
      <p>
        <strong>Bonus coins</strong> granted through promotions are spent before purchased coins and
        expire <strong>90 days</strong> after they are issued.
      </p>

      <h3>How you are charged</h3>
      <p>
        You are charged <strong>by the second</strong>, at the rate shown before the session begins.
        That rate is fixed for the duration of the session. Time you do not use is returned to your
        balance automatically when the session ends. A minimum billable period of{' '}
        <strong>60 seconds</strong> applies once a call connects.
      </p>
      <p>
        If a session cannot connect, you are not charged. If your balance runs out, we warn you
        before the session ends and you are charged only for the time actually used.
      </p>

      <h2>5. How you must behave</h2>
      <p>The following will end a session immediately and may permanently close your account:</p>
      <ul>
        <li>Sexual, romantic or suggestive conduct of any kind, in either direction</li>
        <li>Harassment, threats, abuse, hate speech, or intimidation</li>
        <li>Asking a companion to move the conversation off the platform</li>
        <li>Requesting or sharing personal contact details</li>
        <li>Recording a session without the other person&rsquo;s knowledge and consent</li>
        <li>Impersonating another person, or misrepresenting your age</li>
        <li>Any unlawful activity</li>
      </ul>
      <p>
        <strong>Companions may end any session at any time</strong>, without giving a reason and
        without penalty to them.
      </p>

      <h2>6. Companions</h2>
      <p>
        Companions are <strong>independent contractors</strong>, not our employees. We verify their
        identity and age, and we set the rate they are paid, but we do not control the content of
        individual conversations.
      </p>
      <p>
        Companions are paid a fixed rupee amount per minute delivered. Payouts, taxes and the
        payment cycle are governed by the separate Companion Agreement.
      </p>

      <h2>7. Your account</h2>
      <p>
        You are responsible for activity on your account and for keeping access to your registered
        mobile number secure. Tell us immediately if you believe your account has been compromised.
      </p>
      <p>
        We may suspend or close an account that breaches these terms. Where an account is closed for
        a breach, <strong>unconsumed coins may be forfeited</strong>.
      </p>
      <p>
        You may close your account at any time. Closing it does not automatically refund unconsumed
        coins — see the <a href="/refunds">Refunds policy</a>.
      </p>

      <h2>8. Availability</h2>
      <p>
        We do not guarantee that a companion will be available at any particular time, or that calls
        will be free of interruption. Call quality depends on your network and on third-party
        infrastructure we do not control.
      </p>

      <h2>9. Liability</h2>
      <p>
        <strong>[TO BE DRAFTED BY COUNSEL]</strong> — limitation of liability, exclusion of
        consequential loss, and an aggregate cap. Counsel should consider the cap carefully given
        the emotional-support context and note that a limitation which is unreasonable may not be
        enforceable.
      </p>

      <h2>10. Changes to these terms</h2>
      <p>
        We may update these terms. Material changes will be notified in the app before they take
        effect. Continuing to use the service after that means you accept the updated terms.
      </p>

      <h2>11. Governing law and disputes</h2>
      <p>
        These terms are governed by the laws of India. Disputes are subject to the exclusive
        jurisdiction of the courts at <strong>[CITY]</strong>.
      </p>
      <p>
        <strong>[TO BE DRAFTED BY COUNSEL]</strong> — decide whether to include an arbitration
        clause, and confirm the jurisdiction clause is enforceable against consumers under the
        Consumer Protection Act 2019.
      </p>

      <h2>12. Contact</h2>
      <p>
        Questions about these terms, or a complaint, go to our{' '}
        <a href="/contact">Contact and Grievance</a> page.
      </p>
    </LegalLayout>
  );
}
